/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Interval
 */
export type InstructionQuoteRequestAttributesScheduleInterval = typeof InstructionQuoteRequestAttributesScheduleInterval[keyof typeof InstructionQuoteRequestAttributesScheduleInterval];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InstructionQuoteRequestAttributesScheduleInterval = {
  TWO_MINUTES: 'TWO_MINUTES',
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  YEARLY: 'YEARLY',
} as const;
